// Depends on Endpoint
var PropertyView = (function () {
  var tbody, fields, fieldMap, timg,
    focus,
    PLACEHOLDER = "|quote|",
    PLACEHOLDER_RE = new RegExp("\\|quote\\|", 'g'),
    label = {
      '900000000000484002': 'Ambiguous',
      '900000000000482003': 'Duplicate',
      '900000000000485001': 'Erroneous',
      '900000000000486000': 'Limited',
      '900000000000487009': 'Moved elsewhere',
      '723277005': 'Nonconformance to editorial policy component',
      '900000000000483008': 'Outdated',
      '900000000000492006': 'Pending move',
    };

  function isDefined(value) {
    return typeof value != 'undefined';
  }

  function getOrElse(values, defaultValue) {
    var i = 0;
    while (i < values.length) {
      const val = values[i];
      if (isDefined(val)) {
        return val;
      }
      i++;
    }
    return defaultValue;
  }

  function fallbackCopyTextToClipboard(id) {
    var elt = document.getElementById(id);
    elt.focus();
    elt.select();

    try {
      var successful = document.execCommand('copy');
      return successful;
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
      return false;
    }
  }

  function copyElementToClipboard(id) {
    if (!navigator.clipboard) {
      return fallbackCopyTextToClipboard(id);
    }
    var elt = document.getElementById(id),
      text = elt.innerText;
    navigator.clipboard.writeText(text).then(function () {
      return true;
    }, function (err) {
      console.error('Async: Could not copy text: ', err);
      return false;
    });
  }

  function splitItems(str) {
    // Note the second replace; works around bug in Ontoserver (1.13.0 and earlier) where embedded commas are not properly escaped
    var list = str.replace(/\\,/g, PLACEHOLDER)
      .replace(/,(\s+)/g, PLACEHOLDER + "$1");
    return list.split(",").map(function (s) { return s.replace(PLACEHOLDER_RE, ","); }).sort();
  }

  function addListProps(props, id, label, list) {
    var unique_list = list
      .sort()
      .filter(function (s, i, a) {
        return i === 0 || s !== a[i - 1];
      }),
      last = unique_list.length - 1;

    unique_list
      .forEach(function (s, i, a) {
        props.unshift({
          id: i + id.s + id.c,
          rowspan: i == last ? a.length : 0,
          k: i == last ? label : "",
          v: s
        });
      });
  }

  function valueOf(prop) {
    return getOrElse([prop.value, prop.valueString, prop.valueCode, prop.valueUri, prop.valueCoding, prop.valueDateTime, prop.valueBoolean]);
  }

  function getProps(coding, callback) {
    var props = [], count = 0;

    focus = coding;

    function getTranslation(refset, target, prop, cb) {
      if (!coding.v) {
        count++;
        if (count == 2) {
          callback(props, coding.v);
        }
        return;
      }

      Endpoint.translate({
        'url': coding.v + '?fhir_cm=' + refset,
        'system': coding.s,
        'code': coding.c,
        'target': target,
      },
        function (error, data) {
          if (error) {
            console.log(error);
          } else {
            if (focus !== coding) return;	// stale result

            data.parameter
              .filter(function (p) { return p.name === 'match'; })
              .forEach(function (p, i) {
                p.part.forEach(function (pp, j) {
                  if (pp.name === 'concept') {
                    props.push({ id: coding.s + '|' + coding.c + ':' + i + ':' + j, k: prop, v: label[pp.valueCoding.code] || pp.valueCoding.code });
                    // cb({c: pp.valueCoding.code, s:pp.valueCoding.system});
                  }
                });
              });
          }

          count++;
          if (count == 2) {
            callback(props, coding.v);
          }
        }
      );
    }

    if ('http://snomed.info/sct' === coding.s) {
      getTranslation('11000168105', 'https://www.tga.gov.au/australian-register-therapeutic-goods?fhir_vs', 'ARTG Id');
    } else {
      count++;
      if (count == 2) {
        callback(props, coding.v);
      }
    }

    /*
        if (false) // TODO - ?? no such operation in FHIR
        Endpoint.findConceptsByQuery({
            query: ['expression', '=', "ContainedBy(<" + code + ">)"],
            fields: ["id", "code", "label"],
          },
          function(error, rows) {
            if (error) {
              // alert("ERROR: " + error);
              console.log(error);
            } else {
              if (focus !== code) return;	// stale result
    
              rows.forEach(function(d,i) {
                props.push({id: i+":"+code, rowspan: i == 0 ? rows.length : 0, k: i == 0 ? "Refsets" : "", v: d.label});
              });
    
            }
    
            count++;
            if (count == 2) {
              callback(props, coding.v);
            }
          }
        );
        else
    */

    // TODO - handle subproperties
    function processParam(pmap, param) {
      var n = fieldMap[param.name];
      if (n) {
        var vals = pmap[n] = (pmap[n] || []);
        if (param.part) {
          var map = {};
          param.part.forEach(function (p) {
            map[p.name] = valueOf(p);
          });

          if ('designation' === param.name) {
            var use = (map.use || {});
            var trans = map.language && Endpoint.getLanguage() !== map.language;
            var suffix = '';
            if (trans) {
              const lang = map.language.replace(/-x-sctlang-.*$/, '');
              suffix = '<lang>' + lang + '</lang>';
            }

            if ('900000000000003001' === use.code) {
              n = 'Fully specified name' + suffix;
              vals = pmap[n] = (pmap[n] || []);
            } else if ('900000000000013009' === use.code) {
              n = 'Synonym (acceptable)' + suffix;
              vals = pmap[n] = (pmap[n] || []);
            } else if ('display' === use.code) {
              n = 'Display' + suffix;
              vals = pmap[n] = (pmap[n] || []);
            } else if ('preferredForLanguage' === use.code) {
              n = 'Display' + suffix;
              vals = pmap[n] = (pmap[n] || []);
            } else if (!use.system && !use.code) {
              n = 'Designation (other)' + suffix;
              vals = pmap[n] = (pmap[n] || []);
            } else {
              var tok = (use.system || '') + '|' + (use.code || '');
              n = (fieldMap[tok] || tok);
              vals = pmap[n] = (pmap[n] || []);
            }
            var trans = false && map.language && navigator.language !== map.language;
            if (trans) {
              vals.unshift(valueOf(map) + '<lang>(' + map.language + ')</lang>');
            } else {
              vals.unshift(valueOf(map));
            }
          } else {
            n = n[map.code] || map.code;
            vals = pmap[n] = (pmap[n] || []);
            if (map.valueCoding) {
              map.valueString = map.valueCoding.system + '|' + map.valueCoding.code;
            }
            vals.unshift(valueOf(map));
          }
        } else {
          vals.unshift(valueOf(param));
        }
      }
    }

    var codes = [coding];

    Endpoint.lookupConcepts({
      codings: codes,
      fields: fields, // ["synonyms", "effectiveTime", "moduleId", "inactive", "id", "primitive", "code", "fullySpecifiedName", "label"],
    },
      function (error, result) {
        if (error) {
          // debug(error);
        } else {
          if (focus !== coding) return;	// stale result

          result.forEach(function (d, i) {
            var id = codes[i],
              pmap = {};

            d = d.resource.parameter || [];	// unpack

            d.forEach(function (param) {
              processParam(pmap, param);
            });

            Object.keys(pmap)
              .filter(function (k) { return k !== 'Preferred' && k !== 'Fully specified name' && k !== 'Synonym (acceptable)' && k !== 'Synonym (other)' && k !== 'Display' && k !== 'Display (Preferred)'; })
              .sort(function (a, b) { return b.localeCompare(a); })
              .forEach(function (k) {
                addListProps(props, id, k, pmap[k]);
              });

            var acceptable = []; // splitItems(d["termStatus.acceptable.Australian English"]);
            var syn = []; // splitItems(d.synonyms).filter(function (s) { return d.display != s && acceptable.indexOf(s) < 0; });

            // props.unshift({id: id, k: "Effective Time", v: d.effectiveTime});
            // props.unshift({id: id, k: "Module Id", v: d.moduleId});
            // props.unshift({id: id, k: "Primitive", v: d.primitive});
            // props.unshift({id: id, k: "Active", v: d.active});

            // addListProps(props, "o"+id, "Synonyms (other)", syn);
            // addListProps(props, "a"+id, "Synonyms (acceptable)", acceptable);

            // props.unshift({id: id, k: "Full Name", v: d.fullySpecifiedName});
            // props.unshift({id: id, k: "Preferred", v: d.name});
            ["Synonym (other)", 'Synonym (acceptable)', 'Fully specified name', 'Display', 'Preferred'].forEach(function (k) {
              pmap[k] && addListProps(props, id, k, pmap[k]);
            });
            props.unshift({ id: id.c, k: "Code", v: id.c });
            props.unshift({ id: id.s, k: "System", v: id.s });

          });

          function handleInactive(coding) {
            // TODO - fix implementation; indexOf may not work for codings
            if (FocusManager.getFocus().indexOf(coding) < 0) {
              FocusManager.toggleFocus([coding]);
            }
          }

          if ('http://snomed.info/sct' === coding.s) {
            props
              .filter(function (p) { return p.k === 'Inactive' && isDefined(p.v); })
              .forEach(function (p) {
                count--;
                getTranslation('900000000000526001', 'http://snomed.info/sct?fhir_vs', 'Replaced By', handleInactive);
                count--;
                getTranslation('900000000000527005', 'http://snomed.info/sct?fhir_vs', 'Same As', handleInactive);
                count--;
                getTranslation('900000000000523009', 'http://snomed.info/sct?fhir_vs', 'Possibly Equivalent To');

                count--;
                getTranslation('900000000000489007', 'http://snomed.info/sct?fhir_vs', 'Inactivation Reason');
              });
          }
        }

        count++;
        if (count == 2) {
          callback(props, coding.v);
        }
      }
    );

  }

  function selectElementText(el, win) {
    win = win || window;
    var doc = win.document, sel, range;
    if (win.getSelection && doc.createRange) {
      sel = win.getSelection();
      range = doc.createRange();
      range.selectNodeContents(el);
      sel.removeAllRanges();
      sel.addRange(range);
    } else if (doc.body.createTextRange) {
      range = doc.body.createTextRange();
      range.moveToElementText(el);
      range.select();
    }
  }

  function isSctConceptId(id) {
    // 6-18 digits
    // 3rd last is a 1 or a 0
    // 2nd last is a 0
    // last is a check digit
    return /^[1-9][\d]{1,14}[10]0[\d]$/.test(id);
  }

  return {
    settings: {
      tbody: ".properties",
      fields: ["effectiveTime", "moduleId", "inactive", "sufficientlyDefined", "code", "fullySpecifiedName", "display",
        "kind", "code", "terms", "codingNote", "exclusion", "abstract", "postcoordinationScale",
      ],
      fieldMap: {},
      dragTable: false,
    },
    init: function () {
      var s = this.settings;
      tbody = d3.select(s.tbody);
      fieldMap = s.fieldMap;
      fields = s.fields.concat(Object.keys(fieldMap));
      if (s.dragTable) {
        timg = d3.select(tbody.property("parentElement").getElementsByTagName("th")[1])
          .append("img")
          .attr("src", "move16.png")
          .attr("title", "drag value")
          .style("float", "right");
      }
    },
    clear: function () {
      var prop = tbody
        .selectAll(".prop")
        .remove();
    },
    showConcept: function (coding) {
      getProps(coding, this.showProps);
    },
    showProps: function (props, version) {
      var prop = tbody
        .selectAll(".prop")
        .data(props.filter(function (p) { return isDefined(p.v); }), function (d, i) { return i + ":" + d.id + ":" + d.k; });

      if (timg) {
        d3.select(tbody.property("parentElement").getElementsByTagName("img")[0])
          .attr("draggable", "true")
          .on("dragstart", function (d) {
            d3.event.dataTransfer.setData('text', props.reduce(function (b, p) { return b + p.k + "\t" + p.v + "\n"; }, ""));
            d3.event.dataTransfer.setDragImage(tbody.property("parentElement"), -6, 0);
            d3.event.stopPropagation();
          });
      }

      prop.enter().append("tr")
        .attr("class", "prop")
        .style("background", function (d) {
          return ("Active" === d.k && "false" === d.v) ? "yellow" : "";
        })
        .each(function (d, i) {
          var row = d3.select(this),
            val,
            k = d.k,
            v = d.v;
          if ("Fully Defined" === k) {	// Prefer to call this "primitive" for now
            k = "Primitive";
            v = !v;
          }
          if (k && k !== '|') {
            var lbl = row.append("td")
              // .attr("id", "label" + i)
              .attr("rowspan", function (d) { return d.rowspan ? d.rowspan : ""; });

            if (typeof k === 'string' && k.endsWith('</lang>')) {
              var match = k.match(/^(.*?)<lang>(.*?)<\/lang>$/);
              lbl
                .append("span")
                .text(k == '|' ? '' : match[1]);
              lbl
                .append("span")
                  .style({
                    "float": "right",
                    "font-size": "90%",
                    "font-style": "italic",
                    "max-width": "70px",
                    "overflow": "hidden",
                    "white-space": "nowrap",
                    "text-overflow": "ellipsis",
                  })
                  // .attr("title", match[2])
                  .text(match[2]);
            } else {
              lbl
                // .append("span")
                .text(k == '|' ? '' : k);
            }
          }

          val = row.append("td");	// the value cell

          if (k !== "Code" && isSctConceptId(v)) {
            val.append("a")
              .attr("id", "value" + i)
              .attr("href", undefined)
              .attr("onclick", "FocusManager.setFocus({s: 'http://snomed.info/sct', c: '" + v + "', v: '" + version + "'})")
              .style("cursor", "pointer")
              .style("color", "#69F")
              .style("text-decoration", "underline")
              .text(v);
          } else {
            if (v && typeof v === 'string' && v.endsWith('</lang>')) {
              var match = v.match(/^(.*?)<lang>(.*?)<\/lang>$/);
              val.append("span")
                .attr("id", "value" + i)
                .style("text-decoration", function (d) { return d.strike ? "line-through" : null; })
                .text(match[1]);
              val.append("span")
                .attr("id", "value-lang" + i)
                .style("float", "right")
                .text(match[2]);
            } else {
              val.append("span")
                .attr("id", "value" + i)
                // .attr("draggable", "true")
                // .attr("ondragstart", "event.dataTransfer.setData('text', '"+v+"');")
                .style("text-decoration", function (d) { return d.strike ? "line-through" : null; })
                .text(v);
            }
          }

        });

      prop.exit().remove();
    },
  };

}());

